/* eslint-disable import/prefer-default-export */
export const FREE_PLAN_UNLOCK_EXPERIMENT = 'removing_fpu_ab_testing';

// events
export const CLASS_CHIP_FILTER_CLICKED = 'Class Chip Filter Clicked';
export const CLASS_EXPERIMENT_VARIATION_LOADED =
  'Special class page experiment';
